/* eslint-disable linebreak-style */
import React, { PureComponent } from 'react';
import Select from 'react-select';
import Helmet from 'react-helmet';

import TopMenu from '../../components/TopMenu';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LoadingSpinner from '../../components/LoadingSpinner';

import styles from './styles.module.scss';
import templateStyles from '../../templates/styles.module.scss';
import { INSTDBBUNDLE } from '../../utils/ui-bundle';

const dataUrl = 'https://us-central1-fao-aquastat.cloudfunctions.net/getAquastatInstitutionsDBInt';
const lang = 'FR';
const defLang = 'EN';

class InstitutionsDatabase extends PureComponent {
    allText = INSTDBBUNDLE.ALL[lang];

    pageSize = 25;

    skip = 0;

    currentPage = 1;

    constructor(props) {
      super(props);
      this.state = {
        institutions: [],
        UnfilteredInstitutions: [],
        instName: '',
        country: '',
        type: '',
        active: '',
        sector: '',
        activity: '',
        dataLoaded: false,
        selectedCountry: [],
        selectedType: [],
        selectedSector: [],
        selectedActivity: [],
        take: this.pageSize,
        numberOfPages: 0,
      };

      this.handleCountrySelected = this.handleCountrySelected.bind(this);
      this.handleTypeSelected = this.handleTypeSelected.bind(this);
      this.handleSectorSelected = this.handleSectorSelected.bind(this);
      this.handleActivitySelected = this.handleActivitySelected.bind(this);
    }

    async componentDidMount() {
      fetch(dataUrl)
        .then(res => res.json())
        .then((data) => {
          this.setState({
            institutions: data.institutions,
            UnfilteredInstitutions: data.institutions,
            country: data.area,
            type: data.type,
            sector: data.sector,
            activity: data.activity,
            dataLoaded: true,
          });
        })
        .catch((err) => { console.error(err); });
    }

    onSearchByName(event) {
      this.setState({ instName: event.target.value, take: this.pageSize }, () => {
        this.resetPaging();
        this.filter();
      });
    }

    resetPaging = () => {
      this.skip = 0;
      this.currentPage = 1;
    }

    valueFromId = (opts, id) => opts.find(o => o.value === id);


    filter = () => {
      const {
        instName,
        country,
        type,
        sector,
        active,
        UnfilteredInstitutions,
        selectedCountry,
        selectedType,
        selectedActivity,
        selectedSector,
        activity } = this.state;

      if (!instName && !country && !type && !sector && !active) {
        this.setState({
          institutions: UnfilteredInstitutions,
        });
      }

      this.setState({
        institutions: UnfilteredInstitutions.filter(inst => inst.Name.toLowerCase().includes(instName.toLowerCase())
                  && ((country && selectedCountry && selectedCountry.length > 0 && selectedCountry[0] !== this.allText) ? (inst.area[`NAME_${lang}`] || inst.area[`NAME_${defLang}`]).toLowerCase() === (selectedCountry[0].toLowerCase()) : true)
                  && ((type && selectedType && selectedType.length > 0 && selectedType[0] !== this.allText) ? (inst.type[`NAME_${lang}`] || inst.type[`NAME_${defLang}`]).toLowerCase().includes(selectedType[0].toLowerCase()) : true)
                  && (activity && selectedActivity && selectedActivity.length > 0 && selectedActivity[0] !== this.allText ? (inst.activities || []).map(act => (act[`NAME_${lang}`] || act[`NAME_${defLang}`])).join(',').toLowerCase().includes(selectedActivity[0].toLowerCase()) : true)
                  && (sector && selectedSector && selectedSector.length > 0 && selectedSector[0] !== this.allText ? (inst.sectors || []).map(sct => (sct[`NAME_${lang}`] || sct[`NAME_${defLang}`])).join(',').toLowerCase().includes(selectedSector[0].toLowerCase()) : true)),
      });
    }

    renderTableData = () => {
      const { institutions, take } = this.state;
      const availableRecordSize = institutions.length;
      this.setState({ numberOfPages: Math.ceil(availableRecordSize / this.pageSize) });

      if (this.skip >= availableRecordSize) {
        this.skip = availableRecordSize - take;
      }

      return institutions.slice(this.skip, take + this.skip)
        .map((inst) => {
          const { Institution_Id, Name, parent_id, area, type, sectors, activities, Acronym, active, replaced_by } = inst;
          return (
            <tr className={styles} key={Institution_Id}>
              <td>{Name} {Acronym && (<i>({Acronym})</i>)}
                {parent_id
                                && (
                                <span>
                                  <br />
                                  <i>{INSTDBBUNDLE.UNDER[lang]}: </i> {parent_id}
                                </span>
                                )
                            }
              </td>
              <td>{area[`NAME_${lang}`] || area[`NAME_${defLang}`]}</td>
              <td className={styles.noWrap}>{(type[`NAME_${lang}`] || type[`NAME_${defLang}`]).split('/').join(' / ')}</td>
              <td>{active.toLowerCase() === 'y' ? INSTDBBUNDLE.YES[lang] : INSTDBBUNDLE.NO[lang]}
                {(replaced_by !== 0 && replaced_by)
                            && (
                            <span>
                              <br />
                              <i>{INSTDBBUNDLE.REPLACEDBY[lang]}</i>: {this.getInstitutionName(replaced_by)}
                            </span>
                            )}
              </td>
              <td>{sectors && sectors.map(sct => (sct[`NAME_${lang}`] || sct[`NAME_${defLang}`])).join(', ')}</td>
              <td>{activities && activities.map(act => (act[`NAME_${lang}`] || act[`NAME_${defLang}`])).join(', ')}</td>
            </tr>
          );
        });
    }

    getInstitutionName = (institutionId) => {
      const { UnfilteredInstitutions } = this.state;
      const institution = UnfilteredInstitutions.find(inst => inst.Institution_Id === Number(institutionId));
      return institution ? institution.Name : '';
    }

    handleSectorSelected({ label }) {
      this.setState({ selectedSector: [label], take: this.pageSize }, () => {
        this.resetPaging();
        this.filter();
      });
    }

    handleTypeSelected({ label }) {
      this.setState({ selectedType: [label], take: this.pageSize }, () => {
        this.resetPaging();
        this.filter();
      });
    }

    handleCountrySelected({ label }) {
      this.setState({ selectedCountry: [label], take: this.pageSize }, () => {
        this.resetPaging();
        this.filter();
      });
    }

    handleActivitySelected({ label }) {
      this.setState({ selectedActivity: [label], take: this.pageSize }, () => {
        this.resetPaging();
        this.filter();
      });
    }

    clearSearchCriteria() {
      this.setState(
        {
          instName: '',
          selectedCountry: null,
          selectedType: [this.allText],
          selectedSector: [this.allText],
          selectedActivity: [this.allText],
        }, () => {
          this.filter();
        },
      );
    }

    renderTableHeader = () => (
      <tr key="header">
        <th>{INSTDBBUNDLE.INST[lang].toUpperCase()}</th>
        <th>{INSTDBBUNDLE.CNTRY[lang].toUpperCase()}</th>
        <th>{INSTDBBUNDLE.TYP[lang].toUpperCase()}</th>
        <th>{`${INSTDBBUNDLE.ACTIVE[lang].toUpperCase()}`}<br />{`(${INSTDBBUNDLE.YES[lang]}/${INSTDBBUNDLE.NO[lang]})`}</th>
        <th>{INSTDBBUNDLE.SCTR[lang].toUpperCase()}</th>
        <th>{INSTDBBUNDLE.ACTIVITY[lang].toUpperCase()}</th>
      </tr>
    )

    itemsPerPage(size) {
      this.setState({
        take: size,
      }, () => this.filter());
    }

    pageSelected(pageNumber) {
      this.currentPage = pageNumber;
      this.skip = 25 * (pageNumber - 1);
    }

    nextPage() {
      this.currentPage += 1;
      this.skip = 25 * (this.currentPage - 1);
    }

    previousPage() {
      this.currentPage -= 1;
      this.skip = 25 * (this.currentPage - 1);
    }

    renderMetadata() {
      const { institutions, numberOfPages } = this.state;
      return (
        <div className={styles.metadata}>
          <div className={styles.pagingInfo}>
            {institutions.length} <span>{institutions.length > 1 ? INSTDBBUNDLE.INSTS[lang] : INSTDBBUNDLE.INST[lang]}</span>
          </div>
          <div className={styles.pagination}>
            <ul>
              {(this.currentPage - 1 > 0) && <li className={styles.back}><a href="#" onClick={this.previousPage.bind(this)}>&#60;&#60;</a></li>}
              {(this.currentPage - 2 > 0) && <li><a href="#" onClick={this.pageSelected.bind(this, this.currentPage - 2)}>{this.currentPage - 2}</a></li>}
              {(this.currentPage - 1 > 0) && <li><a href="#" onClick={this.pageSelected.bind(this, this.currentPage - 1)}>{this.currentPage - 1}</a></li>}
              <li className={styles.currentPage}>{this.currentPage}</li>
              {(this.currentPage + 1 < numberOfPages) && <li><a href="#" onClick={this.pageSelected.bind(this, this.currentPage + 1)}>{this.currentPage + 1}</a></li>}
              {(this.currentPage + 2 < numberOfPages) && <li><a href="#" onClick={this.pageSelected.bind(this, this.currentPage + 2)}>{this.currentPage + 2}</a></li>}
              {(this.currentPage + 1 < numberOfPages) && <li className={styles.next}><a href="#" onClick={this.nextPage.bind(this)}>&#62;&#62;<i className="fa fa-angle-double-right" /></a></li>}
            </ul>
          </div>
        </div>
      );
    }

    renderSearchArea() {
      const {
        selectedCountry,
        selectedType,
        selectedSector,
        selectedActivity,
        instName,
        country,
        type,
        sector,
        activity,
      } = this.state;

      const countryOptions = country ? [...[{ label: this.allText, value: this.allText }], ...country.map(cnt => ({ label: (cnt[`FAO_SHORT_NAME_${lang}`] || cnt[`FAO_SHORT_NAME_${defLang}`]), value: cnt.AREA_ID }))] : [];
      const typeOptions = type ? [...[{ label: this.allText, value: this.allText }],
        ...type.filter(t => t.VALID !== 0)
          .sort((cur, pre) => (cur[`NAME_${lang}`] || cur[`NAME_${defLang}`]).localeCompare((pre[`NAME_${lang}`] || pre[`NAME_${defLang}`])))
          .map(t => ({ label: (t[`NAME_${lang}`] || t[`NAME_${defLang}`]), value: t.Institution_Type_Id }))] : [];
      const sectorOptions = sector ? [...[{ label: this.allText, value: this.allText }],
        ...sector.sort((cur, pre) => (cur[`NAME_${lang}`] || cur[`NAME_${defLang}`]).localeCompare((pre[`NAME_${lang}`] || pre[`NAME_${defLang}`])))
          .map(t => ({ label: (t[`NAME_${lang}`] || t[`NAME_${defLang}`]), value: t.SECTOR_ID }))] : [];
      const activityOptions = activity ? [...[{ label: this.allText, value: this.allText }],
        ...activity
          .filter(a => a.VALID !== 0)
          .sort((cur, pre) => (cur[`NAME_${lang}`] || cur[`NAME_${defLang}`]).localeCompare((pre[`NAME_${lang}`] || pre[`NAME_${defLang}`])))
          .map(a => ({ label: (a[`NAME_${lang}`] || a[`NAME_${defLang}`]), value: a.ACTIVITY_ID }))] : [];

      return (
        <div className={styles.filterWrapper}>
          <div>
            <label>{INSTDBBUNDLE.FILTERBYINST[lang]}</label>
            <input type="text" placeholder={INSTDBBUNDLE.SRCHINST[lang]} value={instName} onChange={this.onSearchByName.bind(this)} />
          </div>
          <div>
            <label>{INSTDBBUNDLE.FILTERBYCNT[lang]}</label>
            <Select
              value={this.valueFromId(countryOptions, selectedCountry)}
              onChange={this.handleCountrySelected}
              options={countryOptions}
              isSearchable
              placeholder={INSTDBBUNDLE.SLCTCNTRY[lang]}
            />
          </div>
          <div>
            <label>{INSTDBBUNDLE.FILTERBYTYP[lang]}</label>
            <Select
              value={this.valueFromId(typeOptions, selectedType)}
              onChange={this.handleTypeSelected}
              options={typeOptions}
              isSearchable
              placeholder={INSTDBBUNDLE.SLCTTYP[lang]}
            />
          </div>
          <div>
            <label>{INSTDBBUNDLE.FILTERBYSCTR[lang]}</label>
            <Select
              value={this.valueFromId(sectorOptions, selectedSector)}
              onChange={this.handleSectorSelected}
              options={sectorOptions}
              isSearchable
              placeholder={INSTDBBUNDLE.SLCTSCTR[lang]}
            />
          </div>
          <div>
            <label>{INSTDBBUNDLE.FILTERBYACTIVITY[lang]}</label>
            <Select
              value={this.valueFromId(activityOptions, selectedActivity)}
              onChange={this.handleActivitySelected}
              options={activityOptions}
              isSearchable
              placeholder={INSTDBBUNDLE.SLCTACTIVITY[lang]}
            />
          </div>
          <div>
            {/* <a href="#" onClick={this.clearSearchCriteria.bind(this)}>clear</a> */}
          </div>
        </div>
      );
    }

    renderBody(institutions) {
      return (
        <div className={styles.institutionsTable}>
          {this.renderMetadata()}
          {<table>
            <tbody>
              {this.renderTableHeader()}
              {institutions.length === 0 ? (
                <tr className={styles.dataStatus}>
                  {this.state.dataLoaded
                    ? <td colSpan="6">{INSTDBBUNDLE.NODATA[lang]}</td>
                    : (
                      <td colSpan="6">
                        <LoadingSpinner />
                      </td>
                    )
                                }
                </tr>
              )
                : (this.renderTableData())}
            </tbody>
           </table>}
        </div>
      );
    }

    render() {
      const { institutions } = this.state;

      return (
        <div>
          <Helmet
            title="AQUASTAT - Système d'information mondial de la FAO sur l'eau et l'agriculture"
            meta={[
              { name: 'description', content: 'FAO AQUASTAT' },
              { name: 'keywords', content: 'fao, water, aquastat, water production, eau' },
            ]}
          />
          <Header siteTitle="AQUASTAT" location={{}} />
          <div className="app-wrapper">
            <h2 className="site-title">AQUASTAT - Système d'information mondial de la FAO sur l'eau et l'agriculture</h2>
            <TopMenu location="/databases/institutions-database" />
            <div className={templateStyles.wrapper}>
              <div className={templateStyles.subMenuWrapper}>
                {this.renderSearchArea()}
              </div>
              {this.renderBody(institutions)}
            </div>
          </div>
          <Footer />
        </div>
      );
    }
}

export default InstitutionsDatabase;
